<template>
    <div class="py-4 md:text-lg flex items-center space-x-1 md:space-x-3 text-gray-600 w-full justify-center">
        <button @click="selectStep('product')" :class="{ 'text-gray-900' : step == 'product' }" class="hover:underline focus:outline-none">Produit</button>
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
        <button @click="selectStep('imei')" :class="{ 'text-gray-900' : step == 'imei' }" class="hover:underline focus:outline-none">IMEI</button>
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
        <button @click="selectStep('customer')" :class="{ 'text-gray-900' : step == 'customer' }" class="hover:underline focus:outline-none">Bénéficiaire</button>
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
        <span :class="{ 'text-gray-900' : step == 'payment' }">Contrat</span>
    </div>
</template>

<script>
export default {
    props: ['step', 'type'],
    methods: {
        selectStep: function(step) {
            this.$emit('select-step', step);
        }
    }
}
</script>